export default __webpack_public_path__ + "static/media/ntt-long.13ac2215.svg";